import { createSlice } from '@reduxjs/toolkit';
import {
  adminSignin,
  getAdminBrokerProposals,
  getAdminBrokers,
  getAdminContacts,
  getAdminProposals,
  getAdminReps,
} from './admin.actions';

const initialState = {
  brokerUsers: [],
  brokerUsersMeta: {},

  repUsers: [],
  repUsersMeta: [],

  contacts: [],
  contactsMeta: {},

  proposals: [],
  proposalsMeta: {},

  brokerProposals: [],
  brokerProposalsMeta: {},

  isLoadingAdminSignin: false,
  isLoadingBrokerUsers: false,
  isLoadingRepUsers: false,
  isLoadingContacts: false,
  isLoadingProposals: false,
  isLoadingBrokerProposals: false,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setBrokerUsersMeta: (state, action) => {
      state.brokerUsersMeta = action.payload;
    },
    setRepUsersMeta: (state, action) => {
      state.repUsersMeta = action.payload;
    },
    setAdminContactsMeta: (state, action) => {
      state.contactsMeta = action.payload;
    },
    setProposalsMeta: (state, action) => {
      state.proposalsMeta = action.payload;
    },
    setBrokerProposalsMeta: (state, action) => {
      state.brokerProposalsMeta = action.payload;
    },

    clearAdminState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(adminSignin.pending, (state) => {
      state.isLoadingAdminSignin = true;
    });
    builder.addCase(adminSignin.fulfilled, (state) => {
      state.isLoadingAdminSignin = false;
    });
    builder.addCase(adminSignin.rejected, (state) => {
      state.isLoadingAdminSignin = false;
    });

    builder.addCase(getAdminBrokers.pending, (state) => {
      state.isLoadingBrokerUsers = true;
    });
    builder.addCase(getAdminBrokers.fulfilled, (state, action) => {
      state.brokerUsers = action.payload;
      state.isLoadingBrokerUsers = false;
    });
    builder.addCase(getAdminBrokers.rejected, (state) => {
      state.isLoadingBrokerUsers = false;
    });

    builder.addCase(getAdminContacts.pending, (state) => {
      state.isLoadingContacts = true;
    });
    builder.addCase(getAdminContacts.fulfilled, (state, action) => {
      const { items, page } = action.payload;

      if (page === 1) {
        state.contacts = items;
      } else {
        state.contacts = [...state.contacts, ...items];
      }

      state.isLoadingContacts = false;
    });
    builder.addCase(getAdminContacts.rejected, (state) => {
      state.isLoadingContacts = false;
    });

    builder.addCase(getAdminProposals.pending, (state) => {
      state.isLoadingProposals = true;
    });
    builder.addCase(getAdminProposals.fulfilled, (state, action) => {
      state.proposals = action.payload;
      state.isLoadingProposals = false;
    });
    builder.addCase(getAdminProposals.rejected, (state) => {
      state.isLoadingProposals = false;
    });

    builder.addCase(getAdminBrokerProposals.pending, (state) => {
      state.isLoadingBrokerProposals = true;
    });
    builder.addCase(getAdminBrokerProposals.fulfilled, (state, action) => {
      state.brokerProposals = action.payload;
      state.isLoadingBrokerProposals = false;
    });
    builder.addCase(getAdminBrokerProposals.rejected, (state) => {
      state.isLoadingBrokerProposals = false;
    });

    builder.addCase(getAdminReps.pending, (state) => {
      state.isLoadingRepUsers = true;
    });
    builder.addCase(getAdminReps.fulfilled, (state, action) => {
      state.repUsers = action.payload;
      state.isLoadingRepUsers = false;
    });
    builder.addCase(getAdminReps.rejected, (state) => {
      state.isLoadingRepUsers = false;
    });
  },
});

export const {
  setBrokerUsersMeta,
  setRepUsersMeta,
  setAdminContactsMeta,
  setProposalsMeta,
  setBrokerProposalsMeta,
  clearAdminState,
} = adminSlice.actions;

export default adminSlice.reducer;
